mutation UploadAssistantAttachment($file: Upload!, $conversationId: ID) {
  uploadAssistantAttachment(file: $file, conversationId: $conversationId) {
    id
    url
    width
    height
  }
}
